<aims-side-menu [component]="permissions.ComponentID.ProjectSupport">
  <ng-template>
    <aims-side-menu-header [component]="permissions.ComponentID.ViewDrawings" [displayText]="'Drafting'"
      [collapsible]="true" [defaultOpen]="true">
      <aims-side-menu-link [route]="'./viewDrawings'" [component]="permissions.ComponentID.ViewDrawings"
        [iconClass]="'fas fa-pencil-alt'">
        View Drawings
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./drawing'" [permission]="'Create'"
          [component]="permissions.ComponentID.Drawing" [iconClass]="'fas fa-plus'">
          Create New Drawing
      </aims-side-menu-link>
    </aims-side-menu-header>

    <aims-side-menu-header [component]="permissions.ComponentID.View332s" [displayText]="'Engineering'"
      [collapsible]="true" [defaultOpen]="true">
      <aims-side-menu-link [route]="'./engineeringConfig'" [component]="permissions.ComponentID.EngineeringConfig"
        [iconClass]="'fas fa-cog'">
        Eng Config
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./oaProjects'" [component]="permissions.ComponentID.OverAndAboveProject"
        [iconClass]="'fas fa-people-carry'">
        {{ oaProjectName }}
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./oa'" [permission]="'Create'"
        [component]="permissions.ComponentID.OverAndAboveProject" [iconClass]="'fas fa-plus'">
        New {{ oaProjectName }}
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'../assetMgmt/viewTTTList'" [component]="permissions.ComponentID.View332s"
        [iconClass]="'fas fa-dollar-sign'">
        View 332s
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'../assetMgmt/requestedTTT'" [component]="permissions.ComponentID.View332s"
        [iconClass]="'fas fa-retweet'">
        Requested 332s
      </aims-side-menu-link>

      <aims-side-menu-link [route]="nonOMLink()" [iconClass]="'far fa-arrow-alt-circle-up'">
        Non O&amp;M Time
      </aims-side-menu-link>
    </aims-side-menu-header>


    <aims-side-menu-header [component]="permissions.ComponentID.EditWasteDrums" [displayText]="'Environmental'"
      [collapsible]="true" [defaultOpen]="true">
      <aims-side-menu-link [route]="'./environmentalConfig'" [component]="permissions.ComponentID.EnvironmentalConfig"
        [iconClass]="'fas fa-cog'">
        Environmental Config
      </aims-side-menu-link>
      <aims-side-menu-link [route]="'./viewWasteDrums'" [component]="permissions.ComponentID.EditWasteDrums"
        [iconClass]="'fas fa-biohazard'">
        View/Edit Waste Drums
      </aims-side-menu-link>
    </aims-side-menu-header>

    <aims-side-menu-header [component]="permissions.ComponentID.QualityControl" [displayText]="'Quality Control'"
      [collapsible]="true" [defaultOpen]="true">

      <aims-side-menu-link [route]="'./qualityControlConfig'" [permission]="'Update'"
        [component]="permissions.ComponentID.QualityControlConfig" [iconClass]="'fas fa-cog'">
        QC Config
      </aims-side-menu-link>

      <aims-side-menu-header [component]="permissions.ComponentID.Observations" [displayText]="'Observation(s)'"
        [collapsible]="true" [defaultOpen]="true">
        <aims-side-menu-link [route]="'./observation'" [permission]="'Create'"
          [component]="permissions.ComponentID.Observations" [iconClass]="'fas fa-plus'">
          Create New Observation
        </aims-side-menu-link>

        <aims-side-menu-header [component]="permissions.ComponentID.CDIs" [displayText]="'CDIs'" [collapsible]="true"
          [defaultOpen]="true">
          <aims-side-menu-link [route]="'./viewOpenCdis'" [component]="permissions.ComponentID.CDIs"
            [iconClass]="'far fa-calendar-alt'">
            Open
          </aims-side-menu-link>
          <aims-side-menu-link [route]="'./viewClosedCdis'" [component]="permissions.ComponentID.CDIs"
            [iconClass]="'fas fa-calendar-check'">
            Closed
          </aims-side-menu-link>
          <aims-side-menu-link [route]="'./viewNotValidCdis'" [component]="permissions.ComponentID.CDIs"
            [iconClass]="'far fa-calendar-times'">
            Not Valid
          </aims-side-menu-link>

          <aims-side-menu-header [component]="permissions.ComponentID.CARs" [displayText]="'CARs'" [collapsible]="true"
            [defaultOpen]="true">

            <aims-side-menu-link [route]="'./viewOpenCars'" [component]="permissions.ComponentID.CARs"
              [iconClass]="'far fa-calendar-alt'">
              Open
            </aims-side-menu-link>
            <aims-side-menu-link [route]="'./viewClosedCars'" [component]="permissions.ComponentID.CARs"
              [iconClass]="'far fa-calendar-check'">
              Closed
            </aims-side-menu-link>
            <aims-side-menu-link [route]="'./viewNotValidCars'" [component]="permissions.ComponentID.CARs"
              [iconClass]="'far fa-calendar-times'">
              Not Valid
            </aims-side-menu-link>
          </aims-side-menu-header>

        </aims-side-menu-header>
      </aims-side-menu-header>

      <aims-side-menu-header [component]="permissions.ComponentID.ReportSchedules" [displayText]="'Report Schedules'"
        [collapsible]="true" [defaultOpen]="true">
        <aims-side-menu-link [route]="'./reportSchedules'" [component]="permissions.ComponentID.ReportSchedules"
          [iconClass]="'fas fa-calendar-check'">
          Monthly
        </aims-side-menu-link>

        <aims-side-menu-link [route]="'./asReqReportSchedules'" [component]="permissions.ComponentID.ReportSchedules"
          [iconClass]="'fas fa-calendar-check'">
          As Required
        </aims-side-menu-link>

      </aims-side-menu-header>

      <aims-side-menu-header [component]="permissions.ComponentID.Observations" [displayText]="'Inspection Report(s)'"
        [collapsible]="true" [defaultOpen]="true">
        <aims-side-menu-link [route]="'./viewInspectionReports'" [component]="permissions.ComponentID.InspectionReports"
          [iconClass]="'far fa-clipboard'">
          View Inspection Reports
        </aims-side-menu-link>
        <aims-side-menu-link [route]="'./inspectionReport'" [permission]="'Create'"
          [component]="permissions.ComponentID.InspectionReports" [iconClass]="'fas fa-plus'">
          Create New Inspection Report
        </aims-side-menu-link>
      </aims-side-menu-header>

      <aims-side-menu-header [displayText]="'QC Reports'" [collapsible]="true" [defaultOpen]="true"
        [component]="permissions.ComponentID.ReportSchedules">
        <aims-side-menu-link [route]="'/reporting/Inspection_Report_PartA/trdp'"
          [component]="permissions.ComponentID.ReportSchedules" [iconClass]="'far fa-clipboard'">
          D011-Part A
        </aims-side-menu-link>

        <aims-side-menu-link [route]="'/reporting/Inspection_Report_PartB/trdp'"
          [component]="permissions.ComponentID.ReportSchedules" [iconClass]="'far fa-clipboard'">
          D011-Part B
        </aims-side-menu-link>

        <aims-side-menu-link [route]="'/reporting/Inspection_Report_PartC/trdp'"
          [component]="permissions.ComponentID.ReportSchedules" [iconClass]="'far fa-clipboard'">
          D011-Part C
        </aims-side-menu-link>

        <aims-side-menu-link [route]="'/reporting/QC_Metrics/trdp'"
          [component]="permissions.ComponentID.ReportSchedules" [iconClass]="'far fa-clipboard'">
          Metrics
        </aims-side-menu-link>

        <aims-side-menu-link [route]="'/reporting/QC_OpenCARsMetrics/trdp'"
          [component]="permissions.ComponentID.ReportSchedules" [iconClass]="'far fa-clipboard'">
          Open CAR Metrics
        </aims-side-menu-link>
      </aims-side-menu-header>


      <aims-side-menu-header [component]="permissions.ComponentID.QcChecklists" [displayText]="'Checklists'"
        [collapsible]="true" [defaultOpen]="true">

        <aims-side-menu-link [route]="'/reporting/QC_Checklist/trdp'" [component]="permissions.ComponentID.QcChecklists"
          [iconClass]="'far fa-clipboard'">
          Print Checklist(s)
        </aims-side-menu-link>

        <aims-side-menu-link [route]="'./questions'" [permission]="'Update'"
          [component]="permissions.ComponentID.QcChecklists" [iconClass]="'fas fa-clipboard-list'">
          Questions
        </aims-side-menu-link>
      </aims-side-menu-header>

    </aims-side-menu-header>
  </ng-template>
</aims-side-menu>
